import {Component, inject, PLATFORM_ID} from '@angular/core';
import {GoogleAnalyticsService} from '../../../shared/analytics/google/google-analytics.service';
import {NgxNumberTickerComponent} from '@omnedia/ngx-number-ticker';
import {Button} from 'primeng/button';
import {NavigatorDirective} from '../../../shared/directive/navigator.directive';
import {formComponentSignal} from '../../../shared/signal/common/form-component.signal';
import {isPlatformBrowser} from '@angular/common';
import {AnalyticsEventCategory, AnalyticsEventName} from '../../../shared/enum/gtm-cookie-consent.enum';
import {Theme} from '../../../shared/enum/theme.enum';
import {PixelService} from '../../../shared/analytics/meta/pixel.service';
import {PixelEventName} from '../../../shared/analytics/meta/types/pixel.types';
import {MicrosoftClarityService} from '../../../shared/analytics/microsoft/microsoft-clarity.service';
import {MicrosoftClarityEvents} from '../../../shared/analytics/microsoft/types/microsoft-clarity-events.enum';
import {
  MicrosoftClaritySessionBumper
} from '../../../shared/analytics/microsoft/types/microsoft-clarity-session-bumper.enum';

@Component({
  selector: 'app-parking-hero',
  imports: [
    NgxNumberTickerComponent,
    Button,
    NavigatorDirective
  ],
  templateUrl: './parking-hero.component.html',
  styleUrl: './parking-hero.component.scss'
})
export class ParkingHeroComponent {

  protected readonly parkingTargetCapacity: number = 1500;
  protected readonly parkingCapacityCounterDuration: number = 3000;
  private readonly platformId = inject(PLATFORM_ID);
  protected readonly isBrowser = isPlatformBrowser(this.platformId)
  protected readonly formComponentSignal = formComponentSignal;

  constructor(
    private readonly googleAnalyticsService: GoogleAnalyticsService,
    private readonly pixelService: PixelService,
    private readonly microsoftClarityService: MicrosoftClarityService) {
  }

  protected trackRequestCta(): void {
    this.googleAnalyticsService.trackEvent({
      event: AnalyticsEventName.RequestCtaClick,
      eventCategory: AnalyticsEventCategory.CTA,
      eventPayload: Theme.PARKING
    });

    this.pixelService.trackEvent(
      PixelEventName.RequestCta, {
        page: Theme.PARKING
      });

    this.microsoftClarityService.trackEvent(
      MicrosoftClarityEvents.RequestCta
    );

    this.microsoftClarityService.upgradeSession(MicrosoftClaritySessionBumper.RequestCtaClicked)
  }
}
